// import aboutData from "../data/about.json"; //关于
// import userAgreementData from "../data/userAgreement.json"; //用户协议
// import parentTutelageData from "../data/parentTutelage.json";  //家长监护工程
// import privacyAgreementData from "../data/privacyAgreement.json"; //隐私协议 

import React, { useState, useEffect,  } from 'react';
import { useParams,useNavigate } from "react-router-dom";







import "../css/about.css"

// const aboutData = require('public/data/about.json');
// const userAgreementData = require('public/data/userAgreement.json');
// const parentTutelageData = require('public/data/parentTutelage.json');
// const privacyAgreementData = require('public/data/privacyAgreement.json');


function About() {

    const navigate=useNavigate()

    const [height, setHeight] = useState("300");


    //获取路由信息
    const params = useParams();
    const [data, setData] = useState("关于我们");
    useEffect(() => {
        switch (params.type) {
            case "parentTutelage":
                setData("家长监护工程")
                break;

            case "userAgreement":
                setData("用户协议")
                break;
            case "privacyAgreement":
                setData("隐私协议")
                break;

            case "about":
                setData("关于我们")
                break;
            case "thirdParty":
                setData("第三方信息共享清单")
                break;
        }
    })


    window.addEventListener('message', function (event) {

        // 检查消息来源是否可信
        // console.log(event.data); // 输出："子页面加载完毕"
        // console.log(event.data);


        if (typeof event.data=="string"&&!event.data.type && event.data.type != "webpackWarnings") {
            if (params.type!=event.data) {
                navigate('/about/'+event.data)
            }
        }

        finishload()


    }, false);
    const finishload = () => {
        var ifm = document.getElementById("iframeId");
        // console.log(ifm.contentDocument.body.scrollHeight)
        var iframeBody = ifm.contentDocument || ifm.contentWindow.document;
        var iframeHeight = iframeBody.body.scrollHeight;
        setHeight(iframeHeight + 100)


    }

    //内容部分
    // let Arr = [];
    // if (data !== null) {
    //     for (let index = 0; index < data.content.length; index++) {
    //         const element = data.content[index];
    //         if (element.titleCenter != undefined) {
    //             Arr.push(<h2 className="titleCenter" key={index * 100 + 1}>{element.titleCenter}</h2>)
    //         }
    //         if (element.title != undefined) {
    //             Arr.push(<h4 key={index * 100 + 2}>{element.title}</h4>)
    //         }
    //         Arr.push(<p dangerouslySetInnerHTML={{ __html: element.paragraph }} key={index * 100 + 3}></p>)

    //     }
    // }






    return (
        <div>
            <header className="header">
                <div>{data}</div>
            </header>
            <main className='main'>
                <div className="contentBox">

                    <iframe id="iframeId" src={"../../myabout.html?data=" + params.type} width="100%" onLoad={finishload} height={height} frameBorder="0" scrolling="no" />

                </div>
            </main>
        </div>
    )
}

export default About;
